module.exports = __webpack_public_path__ + "img/coctail_de_combinacion.828f42ca.jpg";